"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgCloud(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M10.502 3c-4.144 0-7.506 3.334-7.506 7.451l.01.364.01.114-.05.024A5.215 5.215 0 000 15.65c0 2.697 2.087 4.2 4.851 4.2h13.915c2.932 0 5.234-2.386 5.234-5.686l-.004-.236c-.122-3.52-2.974-6.348-6.517-6.47l-.107-.001-.107-.232A7.508 7.508 0 0010.502 3zm0 1.532A5.97 5.97 0 0116.139 8.5a.766.766 0 00.809.505c.102-.011.2-.017.294-.017 2.888 0 5.226 2.318 5.226 5.177 0 2.466-1.629 4.154-3.702 4.154H4.851c-2.006 0-3.32-.945-3.32-2.668a3.69 3.69 0 012.552-3.5.766.766 0 00.517-.851 5.206 5.206 0 01-.072-.849c0-3.268 2.673-5.92 5.974-5.92z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgCloud;
exports.default = _default;